// Swim Books content — edit text, photos and steps here.
export const BOOK_ART = {
  openBook: "https://static.prod-images.emergentagent.com/jobs/11b029b3-b642-4b40-9c88-e3a0ab9cbfec/images/f615e222828a1450ae86bb3dec622476c8f169a8201c2aa4f0e027f63bc631a7.jpeg",
};

export const BOOK_CTA = "Make My Child the Star!";

// Add approved photos of the real book here: { src: "https://...", caption: "Front cover" }
export const BOOK_PHOTOS = [
  { src: "https://customer-assets-lxgj4vgw.emergentagent.net/job_swim-mastery-2/artifacts/57a027a30a514f1e_8C9D4A39-A885-4DD0-AA1D-2264F27E3189.webp", caption: "Hardcover edition" },
];

export const SAMPLE_PAGES = [
  { src: "https://customer-assets-lxgj4vgw.emergentagent.net/job_swim-mastery-2/artifacts/57a027a30a514f1e_8C9D4A39-A885-4DD0-AA1D-2264F27E3189.webp", caption: "The personalized cover", cover: true },
  { src: "/books/spread-1.webp", caption: "This Book Belongs to… your little swimmer" },
  { src: "/books/spread-2.webp", caption: "It's Swim Day!" },
  { src: "/books/spread-3.webp", caption: "Let's Make Bubbles!" },
  { src: "/books/spread-4.webp", caption: "Kick, Kick, Kick!" },
  { src: "/books/spread-5.webp", caption: "I Can Do It!" },
];

export const GIFT_SEASONS = [
  { from: [11, 1], to: [12, 24], tag: "Holiday gifting", title: "Give the gift of a story this holiday season" },
  { from: [1, 20], to: [2, 14], tag: "Valentine's Day", title: "Give the gift of a story — made with love" },
  { from: [4, 15], to: [5, 12], tag: "Mother's Day", title: "Give the gift of a story Mom will treasure" },
  { from: [5, 25], to: [6, 21], tag: "Father's Day", title: "Give the gift of a story for Dad's little swimmer" },
];
export const DEFAULT_GIFT_SEASON = { tag: "Birthdays & milestones", title: "Give the gift of a story for their next birthday" };

export const currentGiftSeason = (d = new Date()) => {
  const md = (d.getMonth() + 1) * 100 + d.getDate();
  return GIFT_SEASONS.find((s) => md >= s.from[0] * 100 + s.from[1] && md <= s.to[0] * 100 + s.to[1]) || DEFAULT_GIFT_SEASON;
};

export const FEATURED_BOOK = {
  title: "Learning to Swim with Mimi",
  subtitle: "A Personalized Mimi & Me Swimming Adventure",
  description:
    "One signature Mimi & Me storybook. It's swim day! Coach Mimi helps your little swimmer blow bubbles, kick with a kickboard and discover that every little try counts. Every family receives the same heartwarming story, the same swimming lessons and the same gentle water-safety messages — with your child as the star.",
  personalizedTitle: "What's personalized",
  details: ["Your child's first name throughout the book", "Your child illustrated as the main character", "A personalized cover", "An optional dedication page"],
  note: "The story, lessons and page sequence are the same in every book.",
};

export const OFF_SEASON = {
  title: "Swimming Doesn't Stop When Summer Ends.",
  body: [
    "When cooler weather puts lessons on pause, the learning doesn't have to. Reading together keeps water safety, confidence and the familiar swimming concepts your child has practiced — bubbles, kicking, floating and staying close to a grown-up — fresh and fun until they're back in the pool.",
    "Seeing themselves succeed page after page helps little swimmers return to the water feeling brave, prepared and excited.",
  ],
  disclaimer: "Our books support learning conversations at home. They never replace real swimming instruction or constant, active adult supervision around water.",
};

export const bookSteps = (price) => [
  { title: "Request a book", body: "Fill out the short form below — it only takes a minute." },
  { title: "Coach Mimi contacts you", body: "Mimi reaches out personally for photos and personalization details." },
  { title: "Pay through Zelle", body: `$${price} plus shipping and applicable taxes, using private instructions from Coach Mimi.` },
  { title: "Your book is customized", body: "Coach Mimi personally customizes the signature storybook for your child." },
  { title: "Approve your proof", body: "Review and approve the final digital proof before anything is printed." },
  { title: "Printed & delivered", body: "Your personalized hardcover is printed and delivered to your family." },
];

export const BOOK_STATUSES = ["New Inquiry", "Awaiting Zelle Payment", "Paid", "Creating Book", "Parent Approval", "Printing", "Shipped", "Completed"];
